import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    name: z.string().optional()
});
export const Route = createFileRoute('/org/$organization/settings/teams/')({
    validateSearch: (search)=>SearchParamsSchema.parse(search)
});
